import { render, staticRenderFns } from "./BusinessPharmacyView.vue?vue&type=template&id=64ff4438"
import script from "./BusinessPharmacyView.vue?vue&type=script&lang=js"
export * from "./BusinessPharmacyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports